module.exports = __webpack_public_path__ + "img/biiosmart.e1b6472a.png";